import { COLORS } from '@btime/constants'
import { appendIf } from '@btime/helpers'
import { prop } from 'ramda'
import { useIsOwner, useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'

import { useNavigation } from '../../../../../utils/contexts/NavigationContext'
import { useOpenEditFormModal, useOpenFormInviteHistoryModal } from '../../../../../utils/routes/modals/modalsActions'
import { useOpenShareForm } from '../../../share/_context/ShareFormContext'
import { useRemoveForms } from '../../_requests/removeForms'

export const useRowsActions = (item, ids) => {
  const { t } = useTranslation('listForms')
  const openShareModal = useOpenShareForm()
  const openEditFormModal = useOpenEditFormModal()
  const openFormInviteHistoryModal = useOpenFormInviteHistoryModal()

  const isOwner = useIsOwner()
  let canEdit = useSessionPermission('editForm')
  let canDelete = useSessionPermission('deleteForm')

  const navigate = useNavigation()
  const [deleteItems, bulkState] = useRemoveForms()

  const singleOptions = useMemo(
    () => [
      {
        value: t('resume'),
        icon: 'BsFileRichtext',
        onClick: () => navigate(`/m/v2/forms/${item.id}/form-replies`),
        to: `/forms/${prop('id', item)}/form-replies`
      },

      {
        value: t('share'),
        icon: 'BsLink45Deg',
        onClick: () => openShareModal(item)
      },

      ...appendIf(item?.access === 'private', {
        value: t('sendHistoryMenu'),
        icon: 'BsEnvelope',
        onClick: () => openFormInviteHistoryModal(item.id)
      }),

      ...appendIf(isOwner, {
        value: t('logs'),
        icon: 'RiTimeLine',
        onClick: () => navigate(`/logs?entityUserIds=${item.id}`),
        to: `/logs?entityUserIds=${item?.id}`
      }),

      ...appendIf(canEdit, {
        value: t('edit'),
        icon: 'BsPencil',
        onClick: () => openEditFormModal(item.id)
      }),

      ...appendIf(canDelete, {
        value: t('remove'),
        color: COLORS.red,
        icon: 'BsTrash',
        onClick: () => deleteItems([item.id])
      })
    ],
    [item, deleteItems, openShareModal, canDelete, canEdit, navigate, openFormInviteHistoryModal, t]
  )

  const multiOptions = useMemo(
    () => [
      ...appendIf(isOwner, {
        value: t('logs'),
        icon: 'RiTimeLine',
        onClick: () => navigate(`/logs?entityUserIds=${ids?.join(',')}`),
        to: `/logs?entityUserIds=${ids?.join(',')}`
      }),

      ...appendIf(canDelete, {
        value: t('remove'),
        color: COLORS.red,
        icon: 'BsTrash',
        onClick: () => deleteItems(ids)
      })
    ],
    [ids, deleteItems, canDelete, t]
  )

  return [!ids || ids.length === 1 ? singleOptions : multiOptions, bulkState.loading]
}
